{
    "vesselTableConfig": {
        "columns": [
            {
                "fieldName": "vesselName",
                "displayName": "Vessel Name",
                "dataType": "STRING",
                "sortable": true
            },
            {
                "fieldName": "viaNo",
                "displayName": "Via No",
                "dataType": "STRING"
            },
            {
                "fieldName": "igmNo",
                "displayName": "IGM No",
                "dataType": "STRING"
            },
            {
                "fieldName": "portName",
                "displayName": "Port",
                "dataType": "STRING"
            },
            {
                "fieldName": "terminalName",
                "displayName": "Terminal",
                "dataType": "STRING"
            },
            {
                "fieldName": "berthDate",
                "displayName": "Berth Date",
                "dataType": "STRING",
                "sortable": true
            },
            {
                "fieldName": "cutOffDate",
                "displayName": "Cut Off Date",
                "dataType": "STRING",
                "sortable": true
            },
            {
              "fieldName": "active",
              "displayName": "Status",
              "dataType": "BOOLEAN",
              "valueMap": {
                "true": "Active",
                "false": "Inactive"
              },
              "styleConfig": {
                "type": "status"
              }
            },
            {
                "fieldName": "createdDate",
                "displayName": "Created Date",
                "dataType": "DATETIME",
                "sortable": true
              },
            {
                "fieldName": "createdBy",
                "displayName": "Created By",
                "dataType": "STRING",
                "styleConfig": {
                  "type": "user-avatar"
                }
              },
            {
                "fieldName": "modifiedDate",
                "dbName": "modified_date",
                "displayName": "Modified Date",
                "dataType": "DATETIME",
                "sortable": true
              },
            {
                "fieldName": "modifiedBy",
                "dbName": "modified_by",
                "displayName": "Modified By",
                "dataType": "STRING",
                "styleConfig": {
                  "type": "user-avatar"
                }
              }
             
        ]
    },

    "filterConfig": {
    "filterFields": [
        {
            "name": "VESSEL_NAME_CONTAINS",
            "displayLabel": "Vessel Name",
            "dataType": "STRING",
            "supportedOperators": ["EQ"],
            "operatorToFilterMap": {
                "EQ": "VESSEL_NAME_CONTAINS"
            }

        },
        {
          "name": "VIA_NO_CONTAINS",
          "displayLabel": "VIA No",
          "dataType": "STRING",
          "supportedOperators": ["EQ"],
           "operatorToFilterMap": {
            "EQ": "VIA_NO_CONTAINS"
            }
        },
        {
            "name": "IGM_NO_EQUALS",
            "displayLabel": "IGM No",
            "dataType": "STRING",
            "supportedOperators": ["EQ"],
             "operatorToFilterMap": {
              "EQ": "IGM_NO_EQUALS"
            }
        },
        {
        "name": "IS_ACTIVE",
        "displayLabel": "Active",
        "dataType": "BOOLEAN",
        "operatorToFilterMap": {
          "EQ": "IS_ACTIVE"
        }
      }
    ],
        "useNewContract": true

    },


    "searchBarConfig": {
    "placeHolder": "Search vessel porte by name",
    "filters": [
      {
        "name": "VESSEL_NAME_CONTAINS",
        "alias": "vessel_name"
      }
    ]
  },

    "formControls": {
        "formRows": [
            {
                "formGroups": [
                    {
                        "style": {
                            "gridColumn": "span 2"
                        },
                        "control": {
                            "label": "vesselName",
                            "displayLabel": "Vessel Name",
                            "placeHolder": "Enter Vessel Name",
                            "fieldInfo": {
                                "dataType": "text"
                            },
                            "validators": [
                                {
                                    "type": "required",
                                    "message": "Vessel Name is required"
                                }
                            ]
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 2"
                        },
                        "control": {
                            "label": "port",
                            "displayLabel": "Port",
                            "placeHolder": "Select Port",
                            "fieldInfo": {
                                "dataType": "picklist",
                                "lookupDetails": {
                                    "apiUrl": "v1/locations/list",
                                    "filterByKeys": ["NAME_CONTAINS"],
                                    "limit": 10,
                                    "orderBy": { "name": "asc" },
                                    "bindLabel": "name",
                                    "bindValue": "id",
                                    "additionalFilters": [
                                        {
                                            "name": "IS_ACTIVE",
                                            "alias": "active",
                                            "operator": "EQ",
                                            "value": ["true"]
                                        },
                                        {
                                            "name": "LOCATION_TYPE_IN",
                                            "alias": "locType",
                                            "operator": "EQ",
                                            "value": ["PORT"]
                                        }
                                    ],
                                    "displayColumns": [
                                        { "key": "name", "header": "Name" }
                                    ]
                                }
                            },
                            "validators": [
                                {
                                    "type": "autocompleteRequired",
                                    "message": "Port is required"
                                }
                            ]
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 2"
                        },
                        "control": {
                            "label": "terminal",
                            "displayLabel": "Terminal",
                            "disabled": false,
                            "placeHolder": "Select Terminal",
                            "fieldInfo": {
                                "dataType": "picklist",
                                "lookupDetails": {
                                    "apiUrl": "v1/locations/list",
                                    "filterByKeys": ["NAME_CONTAINS"],
                                    "limit": 10,
                                    "orderBy": { "name": "asc" },
                                    "bindLabel": "name",
                                    "bindValue": "id",
                                    "additionalFilters": [
                                        {
                                            "name": "IS_ACTIVE",
                                            "alias": "active",
                                            "operator": "EQ",
                                            "value": ["true"]
                                        },
                                        {
                                            "name": "LOCATION_TYPE_IN",
                                            "alias": "locType",
                                            "operator": "EQ",
                                            "value": ["PORT_TERMINAL"]
                                        }
                                    ],
                                    "displayColumns": [
                                        { "key": "name", "header": "Name" }
                                    ]
                                }
                            },
                            "validators": [
                                {
                                    "type": "autocompleteRequired",
                                    "message": "Terminal is required"
                                }
                            ]
                        }
                    }
                ]
            },

            {
                "formGroups":[
                    {
                        "style": {
                            "gridColumn": "span 2"
                        },
                        "control": {
                            "label": "berthDate",
                            "displayLabel": "Berth Date",
                            "placeHolder": "Select Berth Date",
                            "fieldInfo": {
                                "dataType": "date"
                            },
                            "validators": [
                                {
                                    "type": "required",
                                    "message": "Berth Date is required"
                                }
                            ]
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 2"
                        },
                        "control": {
                            "label": "cutOffDate",
                            "displayLabel": "Cut Off Date",
                            "placeHolder": "Select Cut Off Date",
                            "fieldInfo": {
                                "dataType": "date"
                            }
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 2"
                        },
                        "control": {
                            "label": "voyageNo",
                            "displayLabel": "Voyage No",
                            "placeHolder": "Enter Voyage No",
                            "fieldInfo": {
                                "dataType": "text"
                            },
                            "validators": [
                                {
                                    "type": "required",
                                    "message": "Voyage No is required"
                                }
                            ]
                        }
                    }
                ]
            },

            {
                "formGroups": [
                    {
                        "style": {
                            "gridColumn": "span 2"
                        },
                        "control": {
                            "label": "vesselServiceId",
                            "displayLabel": "Vessel Service ID",
                            "placeHolder": "Enter Vessel Service ID",
                            "fieldInfo": {
                                "dataType": "text"
                            },
                            "validators": [
                                {
                                    "type": "required",
                                    "message": "Vessel Service ID is required"
                                }
                            ]
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 2"
                        },
                        "control": {
                            "label": "viaNo",
                            "displayLabel": "VIA No",
                            "placeHolder": "Enter VIA No",
                            "fieldInfo": {
                                "dataType": "text"
                            },
                            "validators": [
                                {
                                    "type": "required",
                                    "message": "VIA No is required"
                                }
                            ]
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 2"
                        },
                        "control": {
                            "label": "igmNo",
                            "displayLabel": "IGM No",
                            "placeHolder": "Enter IGM No",
                            "fieldInfo": {
                                "dataType": "text"
                            }
                        }
                    }
                ]
            },

            {
                "formGroups":[
                    {
                        "style": {
                            "gridColumn": "span 2"
                        },
                        "control": {
                            "label": "igmDate",
                            "displayLabel": "IGM Date",
                            "placeHolder": "Select IGM Date",
                            "fieldInfo": {
                                "dataType": "date"
                            }
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 2"
                        },
                        "control": {
                            "label": "rotationNo",
                            "displayLabel": "Rotation Number",
                            "placeHolder": "Enter Rotation Number",
                            "fieldInfo": {
                                "dataType": "text"
                            }
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 2"
                        },
                        "control": {
                            "label": "eta",
                            "displayLabel": "ETA",
                            "placeHolder": "Select ETA",
                            "fieldInfo": {
                                "dataType": "date"
                            }
                        }
                    }
                ]
            },

            {
                "formGroups":[
                    {
                        "style": {
                            "gridColumn": "span 2"
                        },
                        "control": {
                            "label": "etd",
                            "displayLabel": "ETD",
                            "placeHolder": "Select ETD",
                            "fieldInfo": {
                                "dataType": "date"
                            }
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 2"
                        },
                        "control": {
                            "label": "parentViaNo",
                            "displayLabel": "Parent Via No",
                            "placeHolder": "Enter Parent Via No",
                            "fieldInfo": {
                                "dataType": "text"
                            }
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 2"
                        },
                        "control": {
                            "label": "holdVessel",
                            "skipLabel": true,
                            "displayLabel": "Hold Vessel",
                            "fieldInfo": {
                                "dataType": "boolean"
                            }
                        }
                    }
                ]
            }
        ]
    }
}
